import { ExternalLink } from 'lucide-react';

// TODO: Раскомментировать когда появятся реальные данные о партнёрах
// const partners = [
//   {
//     name: 'Unity Technologies',
//     logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Unity_Technologies_logo.svg/320px-Unity_Technologies_logo.svg.png',
//     description: 'Предоставляет образовательные лицензии Unity для участников, проводит мастер-классы по игровому движку.',
//     category: 'Технологический партнёр',
//     link: 'https://unity.com',
//   },
//   {
//     name: 'Blender Foundation',
//     logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Blender_logo_no_text.svg/320px-Blender_logo_no_text.svg.png',
//     description: 'Поддерживает направление 3D-моделирования, предоставляет учебные материалы и экспертов для жюри.',
//     category: 'Образовательный партнёр',
//     link: 'https://blender.org',
//   },
//   {
//     name: 'Яндекс',
//     logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/58/Yandex_icon.svg/320px-Yandex_icon.svg.png',
//     description: 'Организует хакатоны, предоставляет облачные ресурсы и стажировки для победителей.',
//     category: 'Генеральный партнёр',
//     link: 'https://yandex.ru',
//   },
//   {
//     name: 'Минцифры Югры',
//     logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Emblem_of_Khanty-Mansi_Autonomous_Okrug.svg/320px-Emblem_of_Khanty-Mansi_Autonomous_Okrug.svg.png',
//     description: 'Оказывает административную и финансовую поддержку, способствует продвижению чемпионата в регионе.',
//     category: 'Организационный партнёр',
//     link: 'https://admhmao.ru',
//   },
//   {
//     name: 'Гильдия игровых разработчиков',
//     logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Game_Developers_Conference_logo.svg/320px-Game_Developers_Conference_logo.svg.png',
//     description: 'Привлекает экспертов индустрии для оценки работ, проводит карьерные консультации.',
//     category: 'Экспертный партнёр',
//     link: 'https://gamedev.ru',
//   },
//   {
//     name: 'Сбер',
//     logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Sberbank_Logo_2020.svg/320px-Sberbank_Logo_2020.svg.png',
//     description: 'Финансирует гранты для победителей, предоставляет доступ к AI-платформам для участников.',
//     category: 'Финансовый партнёр',
//     link: 'https://sber.ru',
//   },
//   {
//     name: 'МГУ им. Ломоносова',
//     logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/Moscow_State_University_seal.svg/320px-Moscow_State_University_seal.svg.png',
//     description: 'Участвует в разработке методических материалов, предоставляет научных консультантов.',
//     category: 'Академический партнёр',
//     link: 'https://msu.ru',
//   },
//   {
//     name: 'VK',
//     logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/VK_Logo_2022.svg/320px-VK_Logo_2022.svg.png',
//     description: 'Обеспечивает медиаподдержку, размещает информацию в соцсетях, предоставляет платформу для командной работы.',
//     category: 'Медиапартнёр',
//     link: 'https://vk.com',
//   },
// ];

// const partnerCategories = [
//   { icon: Building, title: 'Генеральные партнёры', count: 2 },
//   { icon: Award, title: 'Технологические партнёры', count: 3 },
//   { icon: Users, title: 'Экспертные партнёры', count: 4 },
//   { icon: Globe, title: 'Медиапартнёры', count: 2 },
// ];

export default function PartnersPage() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      <div className="text-center mb-16">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900">Партнёры чемпионата</h1>
        <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
          Благодаря поддержке ведущих компаний и организаций мы создаём уникальные возможности для молодых талантов.
        </p>
      </div>

      {/* TODO: Раскомментировать когда появятся реальные данные о партнёрах */}
      {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
        {partnerCategories.map((cat) => (
          <div key={cat.title} className="card text-center">
            <div className="inline-flex p-4 bg-primary-100 rounded-full mb-4">
              <cat.icon className="h-8 w-8 text-primary-600" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900">{cat.title}</h3>
            <p className="text-gray-500 mt-2">{cat.count} организации</p>
          </div>
        ))}
      </div>

      <div className="mb-16">
        <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Все партнёры</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {partners.map((partner) => (
            <div
              key={partner.name}
              className="card hover:shadow-xl transition-shadow flex flex-col"
            >
              <div className="flex items-center justify-center h-32 mb-6">
                <img
                  src={partner.logo}
                  alt={`Логотип ${partner.name}`}
                  className="max-h-full max-w-full object-contain"
                />
              </div>
              <div className="flex-grow">
                <div className="flex justify-between items-start mb-2">
                  <h3 className="text-xl font-bold text-gray-900">{partner.name}</h3>
                  <a
                    href={partner.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary-600 hover:text-primary-800"
                    aria-label={`Сайт ${partner.name}`}
                  >
                    <ExternalLink className="h-5 w-5" />
                  </a>
                </div>
                <span className="inline-block px-3 py-1 text-xs font-semibold bg-gray-100 text-gray-800 rounded-full mb-3">
                  {partner.category}
                </span>
                <p className="text-gray-600 text-sm">{partner.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div> */}

      <div className="card bg-gradient-to-r from-primary-50 to-accent-50">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Стань партнёром чемпионата</h2>
            <p className="text-gray-700 mb-6">
              Если ваша компания или организация хочет поддержать молодые таланты в креативных индустриях,
              мы открыты для сотрудничества. Предлагаем различные форматы партнёрства: спонсорство, экспертиза,
              предоставление технологий, стажировки, медиаподдержка.
            </p>
            <ul className="space-y-3 mb-8">
              <li className="flex items-center">
                <div className="h-2 w-2 rounded-full bg-primary-500 mr-3" />
                <span>Укрепление HR-бренда среди молодёжи</span>
              </li>
              <li className="flex items-center">
                <div className="h-2 w-2 rounded-full bg-primary-500 mr-3" />
                <span>Доступ к талантливым кадрам</span>
              </li>
              <li className="flex items-center">
                <div className="h-2 w-2 rounded-full bg-primary-500 mr-3" />
                <span>Участие в формировании образовательных программ</span>
              </li>
              <li className="flex items-center">
                <div className="h-2 w-2 rounded-full bg-primary-500 mr-3" />
                <span>Медиаупоминания и PR</span>
              </li>
            </ul>
            <a
              href="/contacts"
              className="btn-primary inline-flex items-center"
            >
              Обсудить партнёрство
              <ExternalLink className="ml-2 h-5 w-5" />
            </a>
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Контакты для партнёров</h3>
            <div className="space-y-4">
              <div>
                <p className="font-semibold text-gray-900">Отдел партнёрств</p>
                <p className="text-gray-600">partner@o4ki.online</p>
              </div>
              <div>
                <p className="font-semibold text-gray-900">Телефон</p>
                <p className="text-gray-600">+7 (909) 71-22-777</p>
              </div>
              <div>
                <p className="font-semibold text-gray-900">Адрес</p>
                <p className="text-gray-600">г. Сургут, ул. Майская, 10</p>
              </div>
            </div>
            <div className="mt-8 pt-8 border-t border-gray-200">
              <p className="text-gray-500 text-sm">
                Мы подготовим индивидуальное предложение в течение 3 рабочих дней после обращения.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}